import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Select from "react-select";
import { loading, tokens, select_style, success, GET, POST, PUT, DELETE, gen_password, number, validate, required, getStorage, alert } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Pagination from '@mui/material/Pagination';
import { Modal } from "react-bootstrap";

const r_det = getStorage("role_detail")?.find(item => item.name === "employee")?.role || [];
const [view_r, create_r, update_r, delete_r] = [r_det[0] === 1, r_det[1] === 1, r_det[2] === 1, r_det[3] === 1];

const USER_OPTS = [
  { value: "admin", label: "พนักงานทั่วไป" }, { value: "finance", label: "พนักงานการเงิน" },
  { value: "project_manager", label: "ผู้จัดการประจำโครงการ" }, { value: "center_manager", label: "ผู้จัดการกลาง" }
];

export default class Employee extends Component {
  state = this.initState();

  initState() {
    return {
      modal_create: false, modal_update: false, modal_delete: false, modal_password: false, modal_detail: false,
      page: 1, filter_data_search: "", search_project: "", filter_user_type: null,
      data: null, data_project: [], data_role: [],
      user_id: "", username: "", password: "", user_type: null, role_id: null, full_name: "", address: "", phone: "", pin_number: "", project_list: []
    };
  }

  async componentDidMount() {
    if (!view_r) return;
    loading(true);
    await Promise.all([this.fetchRoles(), this.fetchProjects(), this.fetchData()]);
    loading(false);
  }

  fetchRoles = async () => {
    let r = await GET(tokens, "v1/TH/role-manage/filter-search/page/0?data_search=", null);
    if (r?.status) this.setState({ data_role: r.data.data.map(e => ({ value: e.role_id, label: e.role_name })) });
  };

  fetchProjects = async () => {
    let r = await GET(tokens, "v1/TH/project-manage/filter-search/page/0?data_search=", null);
    if (r?.status) this.setState({ data_project: r.data.data });
  };

  fetchData = async () => {
    loading(true);
    let r = await GET(tokens, `v1/TH/user-admin/filter-search/page/${this.state.page}/${getStorage("project_id")}`, { data_search: this.state.filter_data_search, user_type: this.state.filter_user_type?.value || "" });
    if (r?.status) this.setState({ data: r.data });
    loading(false);
  };

  valPass = (isNew) => {
    const { username, password } = this.state;
    if (isNew && !/^[a-zA-Z0-9]+$/.test(username)) return alert("warning", "แจ้งเตือน", "ชื่อผู้ใช้ต้องประกอบด้วยตัวอักษรและตัวเลขเท่านั้น");
    if (password.length < 4) return alert("warning", "แจ้งเตือน", "รหัสผ่านต้องมีความยาวอย่างน้อย 4 ตัวอักษร");
    if (!/^[a-zA-Z0-9]+$/.test(password)) return alert("warning", "แจ้งเตือน", "รหัสผ่านต้องประกอบด้วยตัวอักษรและตัวเลขเท่านั้น");
    return true;
  };

  handleSave = async (isCreate, isPassOnly = false) => {
    const reqFields = isPassOnly ? ["password"] : ["user_type", "role_id", "full_name", "phone", "project_list"];
    if (isCreate) reqFields.push("username", "password");
    if (validate(this.state, reqFields) || !this.valPass(isCreate)) return;

    loading(true);
    const { user_id, username, password, user_type, role_id, full_name, address, phone, pin_number, project_list } = this.state;
    let payload = { user_id, username, password, user_type: user_type?.value || "", role_id: role_id?.value || "", full_name, address, phone, pin_number, project_list };

    let r = await (isCreate ? POST : PUT)(tokens, `v1/TH/user-admin/${isCreate ? "create" : "update"}`, payload);
    if (r?.status) {
      this.setState(this.initState(), () => { this.fetchRoles(); this.fetchProjects(); });
      success();
      this.fetchData();
    }
    loading(false);
  };

  handleDelete = async () => {
    loading(true);
    let r = await DELETE(tokens, `v1/TH/user-admin/delete/${this.state.user_id}`, null);
    if (r?.status) {
      this.setState(this.initState(), () => { this.fetchRoles(); this.fetchProjects(); });
      success();
      this.fetchData();
    }
    loading(false);
  };

  openModal = (item, type) => {
    let p_data = this.state.data_project.map(d => ({ ...d, selected: item.project_list.some(e => e.project_id === d.project_id) }));
    this.setState({
      [type]: true, data_project: p_data, user_id: item.user_id, username: item.username, password: item.password,
      user_type: USER_OPTS.find(o => o.value === item.user_type) || null,
      role_id: this.state.data_role.find(e => e.value === item.role_id) || null,
      full_name: item.full_name, address: item.address, phone: item.phone, pin_number: item.pin_number,
      project_list: item.project_list.map(e => e.project_id)
    });
  };

  inp = (lbl, key, type = "text", max = null, disabled = false, extra = null) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">{lbl}{required}:</label>
      <input className="form-control border-0 bg-contain validate" type={type} maxLength={max} disabled={disabled} value={this.state[key]}
        onChange={(e) => this.setState({ [key]: type === "tel" ? number(e.target.value) : e.target.value })} />
      {extra && <button className="btn btn-blue text-white ml-2" onClick={async () => this.setState({ [key]: await gen_password(8) })}>Generate</button>}
    </div>
  );

  render() {
    const s = this.state;
    return (
      <div className="w-100 min-vh-100 fade-in">
        {s.loading && <div className="spinner-container"><div className="loading-spinner"></div></div>}
        <Navbar page1="หน้าหลัก" page2="ข้อมูลผู้ใช้" page3="รายชื่อผู้ใช้ทั้งหมด" />
        
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3"><b>รายชื่อผู้ใช้ทั้งหมด</b></h4>
                {create_r && <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => this.setState({ modal_create: true, data_project: s.data_project.map(d => ({ ...d, selected: false })) })}>เพิ่มผู้ใช้งาน</button>}
              </div>

              {view_r && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <div className="d-flex row mx-0">
                    <input type="search" className="form-control wpx-200 bg-contain border-0 mx-1 mb-3" placeholder="พิมพ์คำค้นหา..." value={s.filter_data_search} onChange={(e) => this.setState({ filter_data_search: e.target.value })} />
                    <div className="wpx-200 mx-1 mb-3 px-0">
                      <Select className="form-control bg-contain border-0 select-search" styles={select_style} placeholder="ทุกประเภท" options={[{ value: "", label: "ทุกประเภท" }, ...USER_OPTS]} onChange={(e) => this.setState({ filter_user_type: e })} isClearable value={s.filter_user_type} />
                    </div>
                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.fetchData)}>ค้นหา</button>
                    <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_data_search: "", filter_user_type: null, page: 1 }, this.fetchData)}>รีเซ็ท</button>
                  </div>
                </div>
              )}

              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {["รหัสสมาชิก", "ชื่อลูกค้า", "เบอร์โทร", "ประเภท", "บทบาท", "โครงการ"].map((h, i) => <th key={i} className="text-left">{h}</th>)}
                      {(update_r || delete_r) && <th className="text-center">จัดการ</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {!s.data?.data?.length ? <tr><td colSpan={7} className="text-center">ไม่มีข้อมูล</td></tr> : s.data.data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.user_code || "-"}</td><td>{item.full_name || "-"}</td><td>{item.phone || "-"}</td>
                        <td>{USER_OPTS.find(opt => opt.value === item.user_type)?.label || "ทุกประเภท"}</td><td>{item.role_name || "-"}</td>
                        <td><label className="pointer" onClick={() => this.setState({ modal_detail: true, project_list: item.project_list })}>ดูรายละเอียดเพิ่มเติม</label></td>
                        {(update_r || delete_r) && (
                          <td className="text-center d-flex">
                            {update_r && (
                              <>
                                <label className="wpx-24 hpx-24 bg-success-light rounded-1 d-flex align-items-center justify-content-center mr-2"><label className="icon mx-2 text-success pointer" onClick={() => this.openModal(item, "modal_password")}>{"\uf084"}</label></label>
                                <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mr-2"><label className="icon mx-2 text-primary pointer" onClick={() => this.openModal(item, "modal_update")}>{"\uf304"}</label></label>
                              </>
                            )}
                            {delete_r && <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center"><label className="icon mx-2 text-danger pointer" onClick={() => this.setState({ modal_delete: true, user_id: item.user_id })}>{"\uf2ed"}</label></label>}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {s.data?.data?.length > 0 && (
                <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                  <div><label>แสดง {s.data.end_index} รายการ จาก {s.data.count} รายการ</label></div>
                  <Pagination count={s.data.page_number} page={s.page} color="primary" showFirstButton showLastButton onChange={(e, value) => this.setState({ page: value }, this.fetchData)} />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Modal Create & Update */}
        <Modal show={s.modal_create || s.modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} dialogClassName="modal-w">
          <Modal.Header><Modal.Title><b>{s.modal_create ? "เพิ่มผู้ใช้งาน" : "แก้ไขผู้ใช้งาน"}</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 col-lg-6">
                {this.inp("ชื่อ-นามสกุล", "full_name")}
                {this.inp("เบอร์โทร", "phone", "tel", 10)}
                <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">ประเภทผู้ใช้{required}:</label><Select className="form-control bg-contain border-0 select-search" options={USER_OPTS} styles={select_style} placeholder="ทุกประเภท" isClearable value={s.user_type} onChange={(e) => this.setState({ user_type: e })} /></div>
                <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">บทบาท{required}:</label><Select className="form-control bg-contain border-0 select-search" styles={select_style} options={s.data_role} value={s.role_id} onChange={(e) => this.setState({ role_id: e })} /></div>
                {s.modal_create && (
                  <>
                    {this.inp("Username", "username")}
                    {this.inp("รหัสผ่าน", "password", "text", null, false, true)}
                  </>
                )}
              </div>
              <div className="col-12 col-lg-6">
                <div className="w-100 d-flex align-items-center mb-3"><label className="wpx-140">โครงการ:</label><input type="search" className="form-control w-100 bg-contain border-0 mx-1" placeholder="พิมพ์คำค้นหา..." value={s.search_project} onChange={(e) => this.setState({ search_project: e.target.value })} /></div>
                <small>โครงการที่เลือก {s.data_project.filter(item => item.selected).length} โครงการ</small>
                <div className="w-100 overflow-auto mb-3" style={{ minHeight: "50vh", height: "50vh" }}>
                  <table className="table table-borderless table-striped">
                    <tbody>
                      {!s.data_project.length && <tr><td colSpan={2} className="text-center">ไม่มีข้อมูล</td></tr>}
                      {s.data_project.filter(item => item.project_name.includes(s.search_project)).map((item, index) => (
                        <tr key={index}>
                          <td>{item.project_name || "-"}</td>
                          <td><input type="checkbox" checked={item.selected || false} onChange={(e) => {
                            let dt = [...s.data_project];
                            dt.find(p => p.project_id === item.project_id).selected = e.target.checked;
                            this.setState({ data_project: dt, project_list: dt.filter(p => p.selected).map(p => p.project_id) });
                          }} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="w-100 d-flex mt-3">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_create: false, modal_update: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={() => this.handleSave(s.modal_create)}>{s.modal_create ? "เพิ่ม" : "บันทึก"}</button></div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal Password */}
        <Modal show={s.modal_password} onHide={() => this.setState({ modal_password: false })}>
          <Modal.Header><Modal.Title><b>แก้ไขรหัสผ่าน</b></Modal.Title></Modal.Header>
          <Modal.Body>
            {this.inp("ชื่อ-นามสกุล", "full_name", "text", null, true)}
            {this.inp("รหัสผ่าน", "password", "text", null, false, true)}
            <div className="w-100 d-flex mt-3">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_password: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={() => this.handleSave(false, true)}>บันทึก</button></div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal Delete */}
        <Modal show={s.modal_delete} onHide={() => this.setState({ modal_delete: false })}>
          <Modal.Header><Modal.Title><b>ยืนยันการลบผู้ใช้งาน</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex mb-3"><label>ท่านแน่ใจว่าต้องการลบข้อมูลลูกค้า หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label></div>
            <div className="w-100 d-flex mt-3">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_delete: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1"><button className="btn btn-danger w-100" onClick={this.handleDelete}>ยืนยัน</button></div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal Detail */}
        <Modal show={s.modal_detail} onHide={() => this.setState({ modal_detail: false })}>
          <Modal.Header><Modal.Title><b>รายชื่อโครงการ</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <table className="table table-borderless table-striped">
              <tbody>{s.project_list.map((item, index) => <tr key={index}><td>{item.project_name}</td></tr>)}</tbody>
            </table>
            <div className="w-100 mt-3"><button className="btn btn-primary w-100" onClick={() => this.setState({ modal_detail: false })}>ปิด</button></div>
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}